import { debounce } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isLookupProductsDisabled: false,
      tempProducts: [],
    }
  },

  computed: {
    ...mapGetters({
      products: 'getProducts',
    }),
  },

  methods: {
    lookupProducts: debounce(async function (index, event) {
      if (this.isLookupProductsDisabled || !event) {
        return
      }
      this.data[index].selectize.loading = true
      await this.$store.dispatch('getProductsWithMerge', {
        page: 1,
        limit: 10,
        q: event,
      })
      this.setProductsAvailable()
      this.showFinish(this.$Progress)
      this.data[index].selectize.loading = false
    }, 500),
    handleSelectProduct(index, event) {
      const skuId = event.value
      this.data[index].sku_id = skuId
      this.data[index].item = event.text
      this.data[index].image = this.productImage(skuId)
      this.data[index].queryProductName = event.text
      this.data[index].selectize.loading = false
      this.onPickedSku(skuId, index)
      this.optionSkus = []

      this.isLookupProductsDisabled = true
      setTimeout(() => {
        this.isLookupProductsDisabled = false
      }, 600)
    },
    handleInputBlurProduct(index, event) {
      const data = this.data[index]

      if (data.is_saving_product) {
        return
      }

      if (!data.sku_id && this.optionSkus.length === 0) {
        this.data[index].queryProductName = ''
      }
    },
    handleBlurProduct(index, event) {
      const data = this.data[index]

      if (data.is_saving_product) {
        return
      }

      if (!data.sku_id) {
        this.data[index].queryProductName = ''
      }
    },
    handleKeydownProduct(index, event) {
      if (this.data[index].sku_id) {
        event.preventDefault()
      }
    },
    handleKeyupProduct(index, event) {
      if (this.isLookupProductsDisabled) {
        return
      }

      if (event.key === 'Backspace' && this.data[index].sku_id) {
        this.data[index].queryProductName = ''
      }

      if (!this.data[index].queryProductName) {
        this.data[index].sku_id = ''
        this.data[index].selectize.loading = false
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/orderAutocompleteAccounting.js